export default __webpack_public_path__ + "static/media/2273.6eb11eb9.png";